var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-pbx__0abj",domProps:{"innerHTML":_vm._s(_vm.$t('billing.pbx.validate_your_0ABJ_address_instantly'))},on:{"click":_vm.onValidateClick}})}
var staticRenderFns = []

export { render, staticRenderFns }